/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SetCentralSystemPassThroughTask
 */
export interface SetCentralSystemPassThroughTask {
    /**
     *
     * @type {Array<number>}
     * @memberof SetCentralSystemPassThroughTask
     */
    thirdPartyCsIdList?: Array<number>;
}

/**
 * Check if a given object implements the SetCentralSystemPassThroughTask interface.
 */
export function instanceOfSetCentralSystemPassThroughTask(
    value: object,
): value is SetCentralSystemPassThroughTask {
    return true;
}

export function SetCentralSystemPassThroughTaskFromJSON(
    json: any,
): SetCentralSystemPassThroughTask {
    return SetCentralSystemPassThroughTaskFromJSONTyped(json, false);
}

export function SetCentralSystemPassThroughTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): SetCentralSystemPassThroughTask {
    if (json == null) {
        return json;
    }
    return {
        thirdPartyCsIdList:
            json["thirdPartyCsIdList"] == null
                ? undefined
                : json["thirdPartyCsIdList"],
    };
}

export function SetCentralSystemPassThroughTaskToJSON(
    value?: SetCentralSystemPassThroughTask | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        thirdPartyCsIdList: value["thirdPartyCsIdList"],
    };
}
